export { default } from './Dialog';
export { DialogFooter, DialogHeader, DialogTrigger } from './@radix-styled';
